import styled from 'styled-components'

export const DetailWrapper = styled.div`
  margin-top: 24px;
`

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  &:hover {
    color: #333;
  }
`

export const StatusBadge = styled.div<{ color: string }>`
  background: ${(props) => props.color}20;
  color: ${(props) => props.color};
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
`

export const ConnectionInfo = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const InfoSection = styled.div`
  margin-bottom: 24px;

  h3 {
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 600;
  }
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;

  .label {
    font-size: 12px;
    color: #888;
    text-transform: uppercase;
    margin-bottom: 4px;
    font-weight: 500;
  }

  .value {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
`

export const ConfigSection = styled(InfoSection)`
  .value {
    font-family: monospace;
    background: #f5f5f5;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
  }
`

export const TagsSection = styled.div`
  margin-bottom: 24px;

  h3 {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 600;
  }
`

export const Tag = styled.div`
  background: #e0e0e0;
  color: #666;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
`

export const ActionsSection = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;

  button {
    min-width: 150px;
  }
`

export const StatsCard = styled.div`
  background: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
`

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
`

export const StatLabel = styled.div`
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
`
